import React from "react";
import { useNavigate } from "react-router-dom";
import usePageTitle from "../hooks/usePageTitle";
import { usePartner } from "../context/PartnerContext";

export default function NotFound() {
  usePageTitle("Page Not Found");
  const { appName, tagline } = usePartner();
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "var(--bg-base)", padding: "24px" }}>
      <div style={{ textAlign: "center", maxWidth: 480 }}>
        <div style={{ fontSize: 80, fontWeight: 900, color: "var(--accent)", lineHeight: 1, marginBottom: 8 }}>404</div>
        <div style={{ fontSize: 22, fontWeight: 700, color: "var(--text-main)", marginBottom: 12 }}>Page not found</div>
        <div style={{ fontSize: 14, color: "var(--text-muted)", marginBottom: 32, lineHeight: 1.6 }}>
          The page you're looking for doesn't exist or has been moved.
        </div>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <button onClick={() => navigate(-1)}
            style={{ padding: "10px 24px", borderRadius: "var(--radius-md)", fontSize: 13, fontWeight: 600,
              background: "transparent", border: "1px solid var(--border)", color: "var(--text-muted)", cursor: "pointer" }}>
            ← Go Back
          </button>
          <button onClick={() => navigate("/")}
            style={{ padding: "10px 24px", borderRadius: "var(--radius-md)", fontSize: 13, fontWeight: 600,
              background: "var(--accent)", border: "none", color: "#fff", cursor: "pointer" }}>
            Go to Homepage
          </button>
        </div>
        <div style={{ marginTop: 40, fontSize: 12, color: "var(--text-faint)" }}>
          <span style={{ fontWeight: 700, color: "var(--accent)" }}>{appName || "CrunchAlpha"}</span>{tagline ? " — " + tagline : ""}
        </div>
      </div>
    </div>
  );
}
